(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 45728:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(61878);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 79933:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ PartnersBanners; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var mobx_react_lite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46670);
/* harmony import */ var _PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34268);
/* harmony import */ var _PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _hooks_useEmblaSlider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21471);
/* harmony import */ var _Dots__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63002);
/* harmony import */ var _GalleryModal_components_Arrows_Arrows__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86318);
/* harmony import */ var _providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(27101);
/* harmony import */ var _Skeleton_SkeletonCover__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9792);
/* harmony import */ var _Image_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(49028);






// import { desktopBanners, mobBanners } from './arraysPartnersBanners';




var PartnersBanners = (0,mobx_react_lite__WEBPACK_IMPORTED_MODULE_2__/* .observer */ .Pi)(function(param) {
    var isMobile = param.isMobile, isTablet = param.isTablet, isLandingPage = param.isLandingPage, banners = param.banners;
    var mainResult = (0,_providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_6__/* .useSearchStore */ .Rp)().mainResult;
    var firstLoading = mainResult.isFirstLoading;
    // const partnerBanner = isMobile ? mobBanners : desktopBanners;
    var partnerBanner = banners;
    var ReworkImageUrl = function(url) {
        if (isMobile) {
            return "https://kruiz.online/images/main_page/banners/mobile/".concat(url);
        }
        if (isTablet) {
            return "https://kruiz.online/images/main_page/banners/desktop/".concat(url);
        }
        return "https://kruiz.online/images/main_page/banners/desktop/".concat(url);
    };
    var ref = (0,_hooks_useEmblaSlider__WEBPACK_IMPORTED_MODULE_3__/* .useEmblaSlider */ .r)({
        loop: true
    }, false), ref1 = ref.ref, current = ref.current, onSelectSlide = ref.onSelectSlide, scrollPrev = ref.scrollPrev, scrollNext = ref.scrollNext, prevBtnEnabled = ref.prevBtnEnabled, nextBtnEnabled = ref.nextBtnEnabled;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var interval = setInterval(function() {
            scrollNext();
        }, 4000); // Меняем слайд каждые 4 секунды
        return function() {
            return clearInterval(interval);
        };
    }, [
        scrollNext
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: isMobile ? (_PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9___default().partnerBannerMob) : (_PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9___default().partnersBanner),
        children: firstLoading && !isLandingPage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Skeleton_SkeletonCover__WEBPACK_IMPORTED_MODULE_7__/* .SkeletonCover */ .B, {
            width: 1100,
            height: 220
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9___default().embla),
            ref: ref1,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9___default().emblaContainer),
                    children: partnerBanner === null || partnerBanner === void 0 ? void 0 : partnerBanner.map(function(i, key) {
                        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_PartnersBanner_module_sass__WEBPACK_IMPORTED_MODULE_9___default().emblaSlide),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                href: i === null || i === void 0 ? void 0 : i.page_url,
                                z: true,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image_Image__WEBPACK_IMPORTED_MODULE_8__/* .Image */ .E, {
                                        src: ReworkImageUrl(i.src),
                                        srcSet: ReworkImageUrl(i.srcset)
                                    }),
                                    i === null || i === void 0 ? void 0 : i.imgBanner
                                ]
                            }, key)
                        }, key);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GalleryModal_components_Arrows_Arrows__WEBPACK_IMPORTED_MODULE_5__/* .PrevArrow */ .$B, {
                    onClick: scrollPrev,
                    enabled: prevBtnEnabled
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GalleryModal_components_Arrows_Arrows__WEBPACK_IMPORTED_MODULE_5__/* .NextArrow */ .gV, {
                    onClick: scrollNext,
                    enabled: nextBtnEnabled
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Dots__WEBPACK_IMPORTED_MODULE_4__/* .Dots */ .b, {
                    view: "longDots",
                    spaceBetween: 6,
                    count: partnerBanner === null || partnerBanner === void 0 ? void 0 : partnerBanner.length,
                    topGap: 12,
                    active: current,
                    onSelect: onSelectSlide
                })
            ]
        })
    });
});


/***/ }),

/***/ 87246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* reexport */ GiftsPartners; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/GiftsPartners/giftsPartners.module.sass
var giftsPartners_module = __webpack_require__(45168);
var giftsPartners_module_default = /*#__PURE__*/__webpack_require__.n(giftsPartners_module);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/Image/Image.jsx
var Image = __webpack_require__(49028);
;// CONCATENATED MODULE: ./components/GiftsPartners/GiftsPartners.jsx






var gift = [
    {
        photo: "/giftPartners/giftOne.jpg"
    },
    {
        photo: "/giftPartners/giftTwo.jpg"
    },
    {
        photo: "/giftPartners/giftThree.jpg"
    },
    {
        photo: "/giftPartners/giftFour.jpg"
    },
    {
        photo: "/giftPartners/giftFive.jpg"
    }, 
];
var GiftsPartners = function() {
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (giftsPartners_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    variant: "heading-1",
                    children: "Подарки от партнеров"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: router.route === "/sea" ? "/novogodniy-keshbek-za-pokupku-kruizov?type=sea" : "/novogodniy-keshbek-za-pokupku-kruizov",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (giftsPartners_module_default()).giftPhoto,
                    children: gift.map(function(i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: i.photo,
                            alt: "",
                            width: 206,
                            height: 160,
                            className: (giftsPartners_module_default()).giftImage
                        });
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/GiftsPartners/index.js



/***/ }),

/***/ 79829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* reexport */ Promotions; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/MainPage/Promotions/promotions.module.sass
var promotions_module = __webpack_require__(68806);
var promotions_module_default = /*#__PURE__*/__webpack_require__.n(promotions_module);
// EXTERNAL MODULE: ./components/Text/index.js + 1 modules
var Text = __webpack_require__(82372);
// EXTERNAL MODULE: ./components/MainPage/Promotions/components/promotion.module.sass
var promotion_module = __webpack_require__(62637);
var promotion_module_default = /*#__PURE__*/__webpack_require__.n(promotion_module);
;// CONCATENATED MODULE: ./components/MainPage/Promotions/components/Promotion.jsx




var Promotion = function(param) {
    var img = param.img, title = param.title, link = param.link, isMobile = param.isMobile, percent = param.percent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
        className: (promotion_module_default()).item,
        href: link,
        rel: "noreferrer",
        children: [
            " ",
            title === "Акции на 2025 год" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (promotion_module_default()).percent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (promotion_module_default()).percentLeft,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                            variant: "textShadowSmall",
                            colorText: "white",
                            children: [
                                "до",
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* Text */.x, {
                        variant: "textShadow",
                        colorText: "white",
                        children: [
                            percent,
                            "%"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: img,
                width: 128,
                height: 128,
                className: (promotion_module_default()).img,
                alt: "",
                loading: "lazy"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: (promotion_module_default()).title,
                children: title
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/MainPage/Promotions/components/index.js


// EXTERNAL MODULE: ./hooks/useEmblaSlider.js
var useEmblaSlider = __webpack_require__(21471);
// EXTERNAL MODULE: ./components/Dots/index.js + 1 modules
var Dots = __webpack_require__(63002);
// EXTERNAL MODULE: ./lib/YaAndGaHelper.js + 2 modules
var YaAndGaHelper = __webpack_require__(38214);
;// CONCATENATED MODULE: ./components/MainPage/Promotions/Promotions.jsx








var discounts = [
    {
        title: "Акции на 2025 год",
        photo: "/images/kkk/11.jpg",
        percent: "25",
        href: "/discount"
    },
    {
        title: "Лучшее предложение дня!",
        photo: "/images/kkk/12.jpg",
        percent: "16",
        href: "/discount/best_day"
    },
    // {
    //   title: 'Кэшбэк 20%',
    //   photo: '/images/kkk/10.jpg',
    //   percent: '15',
    //   href: '/cashback',
    // },
    {
        title: "Раннее бронирование",
        photo: "/images/kkk/1.jpg",
        percent: "10",
        href: "/discount/rannee_bron"
    },
    {
        title: "Медицинским работникам",
        photo: "/images/kkk/2.jpg",
        percent: "20",
        href: "/discount/discount_medics"
    },
    {
        title: "Пенсионерам и ветеранам",
        photo: "/images/kkk/3.jpg",
        percent: "10",
        href: "/discount/discount_pensioners"
    },
    {
        title: "Семьям с детьми",
        photo: "/images/kkk/4.jpg",
        percent: "15",
        href: "/discount/discount_children"
    },
    {
        title: "Молодым семьям и супругам-юбилярам",
        photo: "/images/kkk/5.jpg",
        percent: "10",
        href: "/discount/discount_married"
    },
    {
        title: "Именинникам",
        photo: "/images/kkk/6.jpg",
        percent: "10",
        href: "/discount/discount_birthday"
    }, 
];
var Promotions = function(param) {
    var isMobile = param.isMobile;
    var ref = (0,useEmblaSlider/* useEmblaSlider */.r)({
        align: "start",
        dragFree: true
    }), ref1 = ref.ref, current = ref.current, onSelectSlide = ref.onSelectSlide;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (promotions_module_default()).head,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* Text */.x, {
                    variant: "heading-1",
                    component: "h2",
                    children: "Все скидки и акции от операторов"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (promotions_module_default()).list,
                children: discounts.map(function(param, index) {
                    var href = param.href, title = param.title, photo = param.photo, percent = param.percent;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Promotion, {
                        title: title,
                        img: "".concat(photo),
                        link: href,
                        isMobile: isMobile,
                        percent: percent
                    }, "".concat(title, "-").concat(index));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (promotions_module_default()).embla,
                ref: ref1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (promotions_module_default()).emblaContainer,
                        children: discounts.map(function(param) {
                            var href = param.href, title = param.title, photo = param.photo, percent = param.percent;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (promotions_module_default()).emblaSlide,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Promotion, {
                                    title: title,
                                    img: "".concat(photo),
                                    link: href,
                                    isMobile: isMobile,
                                    percent: percent,
                                    onClick: function() {
                                        (0,YaAndGaHelper/* YaAndGaMainPage */.gh)("click_card_sale");
                                    }
                                })
                            }, title);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dots/* Dots */.b, {
                        view: "dynamicWidth",
                        count: discounts.length,
                        active: current,
                        onSelect: onSelectSlide
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/MainPage/Promotions/index.js



/***/ }),

/***/ 61878:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ MainPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2962);
/* harmony import */ var next_useragent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28010);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var classcat__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(83840);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8710);
/* harmony import */ var _providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(27101);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4526);
/* harmony import */ var _components_SearchCruises__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98231);
/* harmony import */ var _components_Intro__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3007);
/* harmony import */ var _styles_mainPage_module_sass__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(3234);
/* harmony import */ var _styles_mainPage_module_sass__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_styles_mainPage_module_sass__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _components_Text__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82372);
/* harmony import */ var _components_Collapsed__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(63145);
/* harmony import */ var _resources_faqItemsIndex__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(57543);
/* harmony import */ var _components_Image_Image__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(49028);
/* harmony import */ var _components_Reviews__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(22334);
/* harmony import */ var _components_MainPage_Subscribe__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(52755);
/* harmony import */ var _components_PopularDestinations__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69044);
/* harmony import */ var _components_MainPage_Promotions__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(79829);
/* harmony import */ var _components_Banner_PartnersBanner_PartnersBanners__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(79933);
/* harmony import */ var _components_PopularCruises__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(63146);
/* harmony import */ var _lib_YaAndGaHelper__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(38214);
/* harmony import */ var _lib_yandexDataLayer__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(12406);
/* harmony import */ var _lib_api__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(79269);
/* harmony import */ var _hooks_useHiddenWithCookie__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(11711);
/* harmony import */ var _components_GiftsPartners__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(87246);
/* harmony import */ var _utils_isBlackFridayCheck__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(66373);
/* harmony import */ var _utils_hashGenerate__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(5413);






















// import { Partners } from '../components/Partners';













var pageConfig = {
    title: "Речные круизы по России 2025 – купить тур на теплоходе, цены",
    description: "Забронируйте круизы 2025 года: речные маршруты по Волге, Каме и Ладоге, а также морские путешествия. Лучшие предложения, скидки и удобная форма поиска! Круиз.онлайн: +7 (495) 877-58-34"
};
var BannerTop = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 9422).then(__webpack_require__.bind(__webpack_require__, 9422)).then(function(mod) {
        return mod.CookieBanner;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9422)
            ];
        }
    }
});
var __N_SSP = true;
function MainPage(param) {
    var uaString = param.uaString, _store = param.store, user = _store.user, searchStore = _store.searchStore, banners = _store.banners, typeSearch = _store.typeSearch, cookies = _store.cookies, main_reviews = param.main_reviews, popDestRiver = param.popDestRiver, canonicalUrl = param.canonicalUrl, popularPopdirs = param.popularPopdirs;
    var ua = (0,next_useragent__WEBPACK_IMPORTED_MODULE_3__/* .useUserAgent */ .FS)(uaString || window.navigator.userAgent);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var query = router.query;
    var isMobile = ua.isMobile, isTablet = ua.isTablet;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((cookies === null || cookies === void 0 ? void 0 : cookies.closeBanner) !== undefined || (cookies === null || cookies === void 0 ? void 0 : cookies.closeBanner) === "false"), closeBanners = ref[0], setCloseBanners = ref[1];
    var currentDate = dayjs__WEBPACK_IMPORTED_MODULE_5___default()();
    var timeToCookie = currentDate.add(1, "h");
    (0,nookies__WEBPACK_IMPORTED_MODULE_4__.setCookie)(null, "closeBanner", "false");
    var openBanner = function() {
        setCloseBanners(false);
        (0,nookies__WEBPACK_IMPORTED_MODULE_4__.setCookie)(null, "closeBanner", "false");
    };
    (0,_hooks_useHiddenWithCookie__WEBPACK_IMPORTED_MODULE_24__/* .useHiddenWithCookie */ ._)(openBanner);
    var title = pageConfig.title, description = pageConfig.description;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref, ref1;
        // Яндекс метрика - информация о пользователи и типе страницы
        (0,_lib_yandexDataLayer__WEBPACK_IMPORTED_MODULE_27__/* .yandexUserLayer */ .p$)(user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.id, user === null || user === void 0 ? void 0 : (ref1 = user.user) === null || ref1 === void 0 ? void 0 : ref1.group, false);
        (0,_lib_YaAndGaHelper__WEBPACK_IMPORTED_MODULE_28__/* .YaAndGaMainPage */ .gh)("isRiverPage");
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (query && Object.keys(query).length > 0) {
            _lib_api__WEBPACK_IMPORTED_MODULE_23__/* .newApi.post */ .zF.post("Base/PushParams", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z)({}, query), {
                url: "/"
            }), {
                headers: {
                    "X-Auth-Token": (0,_utils_hashGenerate__WEBPACK_IMPORTED_MODULE_26__/* .generateAuthHash */ .R)("JiS00ZpF")
                }
            });
        }
    }, [
        query
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_9__/* .SearchStoreProvider */ .YG, {
        hydrationData: {
            user: user,
            searchStore: searchStore,
            banners: banners,
            typeSearch: typeSearch
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_8__/* .RootStoreProvider */ .LD, {
            hydrationData: {
                user: user,
                searchStore: searchStore,
                banners: banners,
                typeSearch: typeSearch
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_2__/* .NextSeo */ .PB, {
                    title: title,
                    description: description,
                    openGraph: {
                        image: "/images/logo.png"
                    },
                    additionalLinkTags: [
                        {
                            rel: "shortcut icon",
                            href: "/favicon.ico?v=2"
                        }, 
                    ],
                    canonical: canonicalUrl
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_10__/* .Layout */ .A, {
                    isMobile: isMobile,
                    isTablet: isTablet,
                    showTopContent: !closeBanners,
                    popularPopdirs: popularPopdirs,
                    topContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BannerTop, {
                            isOpen: closeBanners,
                            onOpen: setCloseBanners,
                            timeToCookie: timeToCookie,
                            isMobile: isMobile,
                            isTablet: isTablet
                        })
                    }),
                    children: [
                        isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_mainPage_module_sass__WEBPACK_IMPORTED_MODULE_31___default().intro),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Intro__WEBPACK_IMPORTED_MODULE_12__/* .Intro */ .p, {
                                isMobile: isMobile,
                                isNewYear: true
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (0,classcat__WEBPACK_IMPORTED_MODULE_32__/* ["default"] */ .Z)((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)({}, (_styles_mainPage_module_sass__WEBPACK_IMPORTED_MODULE_31___default().backgroundImage), (0,_utils_isBlackFridayCheck__WEBPACK_IMPORTED_MODULE_34__/* .isNewYear */ .m)())),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "container--block",
                                children: [
                                    !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_mainPage_module_sass__WEBPACK_IMPORTED_MODULE_31___default().intro),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Intro__WEBPACK_IMPORTED_MODULE_12__/* .Intro */ .p, {
                                            isMobile: isMobile,
                                            isNewYear: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_styles_mainPage_module_sass__WEBPACK_IMPORTED_MODULE_31___default().searchCruises),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SearchCruises__WEBPACK_IMPORTED_MODULE_11__/* .SearchCruises */ .Q, {
                                            typeSearch: typeSearch,
                                            isMobile: isMobile,
                                            chooseType: true,
                                            startPage: true
                                        })
                                    }),
                                    (0,_utils_isBlackFridayCheck__WEBPACK_IMPORTED_MODULE_34__/* .isNewYear */ .m)() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_styles_mainPage_module_sass__WEBPACK_IMPORTED_MODULE_31___default().bannerWrapper),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "/novogodniy-keshbek-za-pokupku-kruizov",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image_Image__WEBPACK_IMPORTED_MODULE_16__/* .Image */ .E, {
                                                            srcSet: "https://kruiz.online/images/bannerFirst.webp",
                                                            src: "https://kruiz.online/images/bannerFirst.jpg",
                                                            loading: "lazy",
                                                            size: true,
                                                            alt: "",
                                                            className: (_styles_mainPage_module_sass__WEBPACK_IMPORTED_MODULE_31___default().banner)
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "/novogodniy-keshbek-za-pokupku-kruizov",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image_Image__WEBPACK_IMPORTED_MODULE_16__/* .Image */ .E, {
                                                            srcSet: "https://kruiz.online/images/bannerSecond.webp",
                                                            src: "https://kruiz.online/images/bannerSecond.jpg",
                                                            loading: "lazy",
                                                            size: true,
                                                            alt: "",
                                                            className: (_styles_mainPage_module_sass__WEBPACK_IMPORTED_MODULE_31___default().banner)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_mainPage_module_sass__WEBPACK_IMPORTED_MODULE_31___default().gift),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_GiftsPartners__WEBPACK_IMPORTED_MODULE_25__/* .GiftsPartners */ .Q, {})
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: !isMobile && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Banner_PartnersBanner_PartnersBanners__WEBPACK_IMPORTED_MODULE_21__/* .PartnersBanners */ .v, {
                                            isMobile: isMobile,
                                            isTablet: isTablet,
                                            banners: banners
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PopularCruises__WEBPACK_IMPORTED_MODULE_22__/* .PopularCruises */ .I, {
                                        isMobile: isMobile,
                                        metriks: "main_river_page_clicking_on_learn_more_buttons_in_popular_cruises_section"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PopularDestinations__WEBPACK_IMPORTED_MODULE_19__/* .PopularDestinations */ .q, {
                                        isMobile: isMobile,
                                        riverPopDest: popDestRiver
                                    }),
                                    main_reviews && main_reviews.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_mainPage_module_sass__WEBPACK_IMPORTED_MODULE_31___default().reviewsHeader),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                                                    variant: "heading-1",
                                                    component: "h2",
                                                    children: "Отзывы"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Reviews__WEBPACK_IMPORTED_MODULE_17__/* .Reviews */ .Z, {
                                                isMobile: isMobile,
                                                items: main_reviews,
                                                link: "/reviews",
                                                metriks: "home_reviews_load_more_click"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MainPage_Promotions__WEBPACK_IMPORTED_MODULE_20__/* .Promotions */ .z, {
                                        isMobile: isMobile
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MainPage_Subscribe__WEBPACK_IMPORTED_MODULE_18__/* .Subscribe */ .x, {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_styles_mainPage_module_sass__WEBPACK_IMPORTED_MODULE_31___default().headFaq),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Text__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                                                    variant: "heading-4",
                                                    children: "Часто задаваемые вопросы"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Collapsed__WEBPACK_IMPORTED_MODULE_14__/* .Collapsed */ .H, {
                                                items: _resources_faqItemsIndex__WEBPACK_IMPORTED_MODULE_15__/* .faqItems */ .t,
                                                shorter: true,
                                                isCruis: true,
                                                onClick: function() {
                                                    (0,_lib_YaAndGaHelper__WEBPACK_IMPORTED_MODULE_28__/* .YaAndGaMainPage */ .gh)("open_block_with_text_content");
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {})
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 45168:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"giftPhoto":"giftsPartners_giftPhoto__AQWbZ"};

/***/ }),

/***/ 62637:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"item":"promotion_item___mC8n","percent":"promotion_percent__5YI6u","percentLeft":"promotion_percentLeft__hVR_x","img":"promotion_img__firbC","title":"promotion_title__C2trA"};

/***/ }),

/***/ 68806:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"head":"promotions_head__twRKT","list":"promotions_list__xzsC_","embla":"promotions_embla__TIJ_v","emblaContainer":"promotions_emblaContainer__XUkVv","emblaSlide":"promotions_emblaSlide____OYL"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3336,718,3108,889,3215,3647,9788,9774,2888,179], function() { return __webpack_exec__(45728); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);